import { apiClient } from '@/lib/auth/api-client';
import type { ImapConnectAnswer, ImapConnectValues } from './components/imap-connect-step';
import type { ImapServer } from '@immo/api-contract';

// Its own file so the company page's import closure never holds `mailbox.connectImap`
// (route-gate coverage scans every file a surface imports).
export async function connectPersonalImap(
  workspaceId: string,
  values: ImapConnectValues & { readonly smtp: ImapServer },
): Promise<ImapConnectAnswer> {
  const result = await apiClient.mailbox.connectImap({ pathParams: { workspaceId }, body: values });

  return result.ok
    ? { ok: true, email: result.body.email }
    : { ok: false, code: result.body.error.code, details: result.body.error.details };
}
